// extracted by mini-css-extract-plugin
export var flip = "index-module--flip--a5072";
export var half = "index-module--half--928ce";
export var image = "index-module--image--88b42";
export var imageTextWrapper = "index-module--imageTextWrapper--efbff";